export const DeleteProfileProposalAPIType = "delete_proposal" as const

export enum UserRole {
  ADMIN = "admin",
  STAKEHOLDER = "stakeholder",
  EMPLOYEE = "employee",
  VISITOR = "visitor"
}

export interface UserInfo {
  id?: string
  name?: string
  email?: string
  picture?: string | null
  roles?: UserRole[]
}

export interface PisaUser {
  _id: string
  email: string
  familyName: string
  givenName: string
  name: string
  salesUserId: string
  serviceUserId?: string
  staff: boolean
}
